import { render, staticRenderFns } from "./UserPortalLogin.vue?vue&type=template&id=67d460b5&scoped=true&"
import script from "./UserPortalLogin.vue?vue&type=script&lang=js&"
export * from "./UserPortalLogin.vue?vue&type=script&lang=js&"
import style0 from "./UserPortalLogin.vue?vue&type=style&index=0&id=67d460b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d460b5",
  null
  
)

export default component.exports